import type { Tenant } from "@repo/types";
import { useOutletContext } from "react-router-dom";

export type TenantContextType = {
  tenant: Tenant | null | undefined;
  isLoading: boolean;
};

export function useTenant() {
  return useOutletContext<TenantContextType>();
}
